import { EsquireClient } from "@/types/clients/esquire";
import LoginData from "@/types/clients/esquire/data/general/login-data";
import { AuthError } from "@/services/auth-errors";
import type { EntryAttribution } from "@/stores/session/entry-attribution";
type ErrorResponse = {
  code?: string;
  message?: string;
  errors?: Record<string, unknown>;
};
export default class LogIn {
  public constructor(private client: EsquireClient) {}

  private async readErrorResponse(response: Response): Promise<ErrorResponse | null> {
    try {
      return await response.json() as ErrorResponse;
    } catch {
      return null;
    }
  }

  public async send(contractId: string, attribution?: EntryAttribution): Promise<LoginData> {
    const response = await this.client.fetch((baseUrl) => {
      const url = new URL(`api/v1/contracts/${contractId}/check-status`, baseUrl);

      if (attribution) {
        if (attribution.buildingId) {
          url.searchParams.set("building_id", attribution.buildingId);
        }

        url.searchParams.set("entry_point", attribution.entryPoint);
        url.searchParams.set("entry_session_id", attribution.entrySessionId);
      }

      return url;
    }, {
      method: "GET"
    });

    if (response.status === 403) {
      throw new AuthError("forbidden");
    }

    if (!response.ok) {
      const error = await this.readErrorResponse(response);

      if (response.status === 400 && error?.message === "inactive") {
        throw new AuthError("unauthorized");
      }

      return new LoginData({
        contract_status: "unavailable",
        contract_id: "",
        routes: {},
        units: [],
        reservation: null
      });
    }

    const result = await response.json();
    return new LoginData(result);
  }
}
